import Reflux from "reflux";
import SiteActions from "./SiteActions";

const TransformActions = Reflux.createActions([
  "align",
  "alignToCanvas",
  "distributeSpace",
  "endTransform",
  "matchSize",
  "ready",
  "redraw",
  "shift",
  "startTransform",
  "transform",
]);

[
  SiteActions.redo,
  SiteActions.undo,
  TransformActions.align,
  TransformActions.alignToCanvas,
  TransformActions.distributeSpace,
  TransformActions.matchSize,
].forEach((action) => action.listen(TransformActions.redraw));

export default TransformActions;
